// Shared campaign tab components (derive their type from context)
import { GamesTab } from '../components/shared/tabs';

// Campaign tab components
import {
  PrizesTab as PrizePopPrizesTab,
  WinnersTab as PrizePopWinnersTab,
  RulesTab as PrizePopRulesTab,
} from '../components/variants/prizePop/tabs';

// Tournament tab components (campaign variant)
import {
  RewardsTab as TournamentRewardsTab,
  RankingTab as TournamentRankingTab,
  RulesTab as TournamentRulesTab,
} from '../components/variants/tournaments/tabs';

// Rebate tab components (campaign variant)
import { RulesTab as RebateRulesTab, WinningsTab as RebateWinningsTab } from '../components/variants/rebate/tabs';

import type {
  CampaignTab,
  CampaignTypes,
  IComponentCampaignTabsMap
} from '../types/campaign.types';

const componentCampaignTabsMap: IComponentCampaignTabsMap = {
  TOURNAMENTS_GAMES_TAB: GamesTab,
  TOURNAMENTS_REWARDS_TAB: TournamentRewardsTab,
  TOURNAMENTS_RANKING_TAB: TournamentRankingTab,
  TOURNAMENTS_RULES_TAB: TournamentRulesTab,
  PRIZE_POP_GAMES_TAB: GamesTab,
  PRIZE_POP_PRIZES_TAB: PrizePopPrizesTab,
  PRIZE_POP_PLAYERS_TAB: PrizePopWinnersTab,
  PRIZE_POP_RULES_TAB: PrizePopRulesTab,
  REBATE_GAMES_TAB: GamesTab,
  REBATE_WINNINGS_TAB: RebateWinningsTab,
  REBATE_RULES_TAB: RebateRulesTab,
};

type TranslateFn = (key: string, fallback: string) => string;

const tabLabels = {
  prize_pop: {
    games: { key: 'campaigns.games', fallback: 'Games' },
    prizes: { key: 'campaigns.prizes', fallback: 'Prizes' },
    players: { key: 'campaigns.winners', fallback: 'Winners' },
    rules: { key: 'campaigns.rules', fallback: 'Rules' },
  },
  tournaments: {
    games: { key: 'campaigns.games', fallback: 'Games' },
    rewards: { key: 'campaigns.rewards', fallback: 'Rewards' },
    ranking: { key: 'campaigns.ranking', fallback: 'Ranking' },
    rules: { key: 'campaigns.rules', fallback: 'Rules' },
  },
  rebate: {
    games: { key: 'campaigns.games', fallback: 'Games' },
    winnings: { key: 'campaigns.winnings', fallback: 'Winnings' },
    rules: { key: 'campaigns.rules', fallback: 'Rules' },
  },
};

const mapTabs = (campaignType: CampaignTypes, t: TranslateFn): CampaignTab[] => {
  const labels = tabLabels[campaignType];

  return (Object.entries(labels) as [CampaignTab['type'], { key: string; fallback: string }][]).map(([type, labelConfig]) => {
    const label = labelConfig.key ? t(labelConfig.key, labelConfig.fallback) : labelConfig.fallback;

    const tabKey = `${campaignType.toUpperCase()}_${type.toUpperCase()}_TAB` as keyof IComponentCampaignTabsMap;
    const tabComponent = componentCampaignTabsMap[tabKey];

    return {
      type,
      label,
      component: tabComponent,
    };
  });
};

export const campaignTabsMapper = (campaignType: CampaignTypes, t: TranslateFn) => ({
  tabs: mapTabs(campaignType, t),
});
